var $ = require( 'jquery' )
var jQuery = $
global.$ = $; // rendre globale (on peut l'utiliser depuis la console F12)
global.jQuery = jQuery;
require( 'bootstrap3' );
var sclbasic = require('node-scl-basic')
var cca = require('../cca');

function run(){
    $( document ).ready( function () {

        var params = sclbasic.util.parseQueryString(window.location.search);
        if (params['fillForm'] === 'dummydata') {
            $('<div style="background:#f0ad4e;color:#000;text-align:center;padding:8px 16px;font-weight:bold;position:sticky;top:0;z-index:9999;">⚠ TEST MODE — form will be pre-filled with dummy data</div>')
                .prependTo('body');
        }

        $.ajax({
            type: 'GET',
            url: BASE_PATH + '/proxy/exams-feed?pretty',
            contentType:    'text/plain',
            beforeSend: function () {
                $('#divAjaxLoader').show();
            },
            complete: function(){
                $('#divAjaxLoader').hide();
            },
            error: function(){
                alert('Erreur Affichage');
                $('#divAjaxLoader').text('Erreur Affichage');
            },
            success: function(dataReceived){
                sclbasic
                    .displayList
                    .displayList(
                        $('table'),
                        {
                            uriOptions : {
                                q : 'exam_cca'
                            },
                            data : dataReceived
                        }
                    );
            }
        });

    });
}

module.exports = {
    run: run
};
